module.exports = __webpack_public_path__ + "static/img/1.62da914.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Empresariales-Multirriesgo-Copropiedades/1.png
// module id = raN5
// module chunks = 0